import(/* webpackMode: "eager" */ "/app/node_modules/sonner/dist/index.mjs");
import(/* webpackMode: "eager" */ "/app/src/app/styles.scss");
import(/* webpackMode: "eager" */ "/app/src/components/Dashboard/index.tsx")